import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { BoxDanger, MnemoLoading, ModalHandler, MSection, SupportoTecnico, Title } from "components/misc";
import { dateHelper, enrollmentEvaluationService, enrollmentService, learningService, networkErrorHelper } from "libs";
import { Button, Icon } from "design-react-kit";
import { COMPANY, LABEL_UNIVERSITY, ROUTES } from "const";

class userEnrollmentEvaluation extends Component {
  state = {
    loading: true,
    loadingError: false,
    course: null,
    rCode: "",
    enrollmentEvaluations: [],
    enrollmentEvaluation: null,
    evaluationBando: null,
    userCourse: null,
    userCourseManifesto: null,
    manifestoBando: null,
    isDeadlinePassed: false,
  };

  goBack() {
    window.history.back();
  }

  componentDidMount() {
    const { rCode } = this.props.match.params;
    this.loadRemote(rCode);
  }

  checkDeadline(bando) {
    const { deadlineDate, deadlineHour } = bando;
    const deadline = `${deadlineDate} ${deadlineHour}`;

    const isDeadlinePassed = dateHelper.isExpired(deadline);

    return isDeadlinePassed;
  }

  isEnrollmentExpired() {
    const { isDeadlinePassed, enrollmentEvaluation } = this.state;

    //if ammesso per scorrimento (dateAdmitted) enable buttons until 12h later
    if (enrollmentEvaluation && enrollmentEvaluation.dateAdmitted) {
      const admittedTime = dateHelper.addHour(enrollmentEvaluation.dateAdmitted, 12);
      const admittedExpired = dateHelper.isExpired(admittedTime);

      //disable buttons if both bando and admittedTime are expired
      return isDeadlinePassed && admittedExpired;
    }

    return isDeadlinePassed;
  }

  onConfirm = () => {
    const { enrollmentEvaluation, enrollmentEvaluations } = this.state;

    const otherEnrollments = enrollmentEvaluations.filter((item) => item.id !== enrollmentEvaluation.id);

    if (otherEnrollments.length > 0) {
      const modalBody = (
        <div>
          <p>
            Al fine di poter procedere con l'immatricolazione, deve preventivamente rinunciare ai seguenti percorsi se non più di suo interesse nel
            rispetto di termini e modalità indicate dal sistema:
          </p>

          <ul className="mt-3">
            {otherEnrollments.map((enrollment, index) => (
              <li key={index}>
                <b>
                  {this.getCourseTitle(enrollment.courseCode, enrollment.courseTitle, enrollment.region)} ({LABEL_UNIVERSITY[enrollment.company]})
                </b>
              </li>
            ))}
          </ul>
        </div>
      );

      ModalHandler.show(null, "Avviso", modalBody, null, null, "Conferma", "Annulla", false, true);
    } else {
      const modalBody = (
        <div>
          <p>Confermi di voler procedere con la l'immatricolazione al percorso specificato?</p>
        </div>
      );

      ModalHandler.show(null, "Avviso", modalBody, null, this.confirmManifestoCourse);
    }
  };

  onReject = () => {
    const { userCourse, course } = this.state;

    const title = this.getCourseTitle(course.code, course.title, userCourse.pluginConfig["region"]);

    ModalHandler.show(
      null,
      "Avviso",
      `Si precisa che la rinuncia non è revocabile e che si procederà allo scorrimento della graduatoria. Conferma la rinuncia di questo percorso: ${title} ?`,
      null,
      this.rejectBandoCourse,
      "Conferma rinuncia",
    );
  };

  confirmManifestoCourse = () => {
    this.setState({ loading: true });
    const { enrollmentEvaluation } = this.state;
    const payload = {
      id: enrollmentEvaluation.enrollmentId,
    };

    enrollmentEvaluationService
      .confirmBandoEnrollment(payload)
      .then(({ data }) => {
        const { userCourseManifesto } = data.payload;

        this.setState({
          userCourseManifesto,
          loading: false,
        });

        if (userCourseManifesto && userCourseManifesto.registrationCode) {
          const paymentLink =
            userCourseManifesto.instituteCompany === COMPANY.UNITELMA || userCourseManifesto.instituteCompany === COMPANY.REGGIO
              ? `${ROUTES.COURSE_PAYMENTS}/${userCourseManifesto.registrationCode}`
              : `${ROUTES.MU_COURSE_PAYMENTS}/${userCourseManifesto.registrationCode}`;

          window.location.href = paymentLink; // `${ROUTES.COURSE_DASHBOARD}/${userCourseManifesto.registrationCode}`;
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        networkErrorHelper.notify(error);
      });
  };

  rejectBandoCourse = () => {
    this.setState({ loading: true, loadingError: false });

    const { enrollmentEvaluation } = this.state;
    const { rCode } = this.props.match.params;
    const payload = {
      id: enrollmentEvaluation.enrollmentId,
    };

    enrollmentEvaluationService
      .rejectBandoEnrollment(payload)
      .then(() => {
        this.loadRemote(rCode);
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  loadRemote(rCode) {
    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {
        const { course, userCourse, userEnrollment } = data.payload;

        //get manifesto from bando
        this.loadManifestoFromBando(userEnrollment.userId, rCode);

        //get userEnrollmentEvaluations
        this.loadUserEnrollmentEvaluations(userEnrollment.bandoedition);

        learningService
          .bandoEvaluationInfo(
            userCourse.pluginConfig["region"],
            course.instituteCompany,            
            userCourse.pluginConfig["competitionClass"],
            userEnrollment.bandoedition,
            course.aa
          )
          .then(({ data }) => {
            const { evaluationBando } = data.payload;

            //check bando deadline
            const isDeadlinePassed = this.checkDeadline(evaluationBando);

            this.setState({ evaluationBando, isDeadlinePassed });
          })
          .catch((error) => {
            if (!networkErrorHelper.is404(error)) {
              networkErrorHelper.notify(error);
            }

            this.setState({ loading: false, loadingError: true });
          });

        learningService
          .myUserEnrollmentEvaluation(userCourse.registrationCode)
          .then(({ data }) => {
            const { enrollmentEvaluation, userCourseManifesto } = data.payload;

            this.setState({ enrollmentEvaluation, userCourseManifesto });
          })
          .catch((error) => {
            if (!networkErrorHelper.is404(error)) {
              networkErrorHelper.notify(error);
            }

            this.setState({ loading: false, loadingError: true });
          });

        this.setState({
          course,
          userCourse,
          userEnrollment,
          loading: false,
          loadingError: false,
          rCode,
        });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }

        this.setState({ loading: false, loadingError: true });
      });
  }

  loadManifestoFromBando(userId, rCode) {
    learningService
      .getManifestoFromBando(userId, rCode)
      .then(({ data }) => {
        const { manifestoBando } = data.payload;
        this.setState({ manifestoBando });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      });
  }

  loadUserEnrollmentEvaluations(bandoedition) {
    if (!bandoedition) return;

    enrollmentEvaluationService
      .myUserEnrollmentEvaluations(bandoedition)
      .then(({ data }) => {
        const enrollmentEvaluations = data.payload.enrollmentEvaluations;
        this.setState({ enrollmentEvaluations });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }

        this.setState({ loading: false, loadingError: true });
      });
  }

  getCourseTitle(courseCode, courseTitle, region) {
    if (!courseTitle || !region) return "";

    const is60CFU =
      courseCode.startsWith("IUL60") || courseCode.startsWith("UM60") || courseCode.startsWith("UNT60") || courseCode.startsWith("RC60");

    if (is60CFU) {
      return `Abilitazione all'insegnamento della classe di concorso ${courseTitle} (Percorsi di formazione iniziale di 60 CFU di cui al D.P.C.M. 4 agosto 2023 - ALL. 1) - ${region.toUpperCase()}`;
    } else {
      return `Abilitazione all'insegnamento della classe di concorso ${courseTitle} (Percorsi di formazione iniziale di 30 CFU di cui al D.P.C.M. 4 agosto 2023 - ALL. 2) - ${region.toUpperCase()}`;
    }
  }

  render() {
    const { loading, loadingError, rCode, course, userCourse, userCourseManifesto, enrollmentEvaluation, evaluationBando, manifestoBando } =
      this.state;

    if (loading) return <MnemoLoading></MnemoLoading>;

    const isExpired = this.isEnrollmentExpired();

    const title = this.getCourseTitle(course.code, course.title, userCourse.pluginConfig["region"]);

    let university = LABEL_UNIVERSITY[course.instituteCompany];

    if (loadingError || !enrollmentEvaluation) {
      return (
        <BoxDanger className="mt-4">
          Si è verificato un errore durante il caricamento della pagina,
          <br />
          <SupportoTecnico />
        </BoxDanger>
      );
    }

    const isApproved = evaluationBando && evaluationBando.isApproved;
    if (!isApproved) {
      return (
        <BoxDanger className="mt-4">
          La graduatoria non è ancora pubblicata.
          <br />
          <SupportoTecnico />
        </BoxDanger>
      );
    }

    const paymentLink =
      course.instituteCompany === COMPANY.UNITELMA || course.instituteCompany === COMPANY.REGGIO
        ? `${ROUTES.COURSE_PAYMENTS}/${userCourseManifesto.registrationCode}`
        : `${ROUTES.MU_COURSE_PAYMENTS}/${userCourseManifesto.registrationCode}`;

    return (
      <>
        <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right">
          <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>

        <Title>Consultazione graduatoria</Title>

        <MSection>
          <p>Gentile Candidata/o,</p>
          <p>
            al fine di una corretta individuazione della propria posizione in graduatoria, le indichiamo di seguito il codice identificativo associato
            alla sua candidatura presentata all' {university} per l' {title}
          </p>
          <p>
            Codice identificativo: <b>{enrollmentEvaluation.gompid}</b>
          </p>
          <h6>
            <a target="blank" href={evaluationBando.url}>
              clicca qui per consultare la graduatoria
            </a>
          </h6>

          {enrollmentEvaluation.status === "ok" && !enrollmentEvaluation.disableEnroll && (
            <>
              {userCourseManifesto ? (
                <>
                  <div>
                    <NavLink to={paymentLink} className="my-5 btn btn-outline-primary">
                      Hai già confermato l'immatricolazione. Procedi con il pagamento della prima rata
                    </NavLink>
                  </div>
                </>
              ) : (
                <>
                  {isExpired ? (
                    <>
                      <BoxDanger className="mt-4">
                        Siamo spiacenti ma il termine per l'immatricolazione risulta scaduto. Per ulteriori informazioni la invitiamo a{" "}
                        <SupportoTecnico />
                      </BoxDanger>
                    </>
                  ) : (
                    <>
                      <Button className="m-4" color="primary bg-dark" onClick={() => this.onConfirm()}>
                        Procedere con l'immatricolazione e il relativo pagamento
                      </Button>
                      <Button className="m-4" color="danger" onClick={() => this.onReject()}>
                        Rinuncia all'immatricolazione
                      </Button>
                    </>
                  )}
                </>
              )}
            </>
          )}

          {manifestoBando && (
            <>
              {manifestoBando.userId < 0 && manifestoBando.status === "closed" && (
                <div className="mt-4">
                  <BoxDanger>
                    Iscrizione al corso chiusa, per ulteriori informazioni la invitiamo a <SupportoTecnico />
                  </BoxDanger>
                </div>
              )}

              {manifestoBando.userId > 0 && manifestoBando.status === "active" && (
                <NavLink className="mx-5 btn btn-outline-primary float-right" to={`${ROUTES.COURSE_DASHBOARD}/${manifestoBando.registrationCode}`}>
                  VAI AL CORSO <Icon icon="it-arrow-right" size="sm" />
                </NavLink>
              )}
            </>
          )}
        </MSection>
      </>
    );
  }
}

export default withRouter(userEnrollmentEvaluation);
